import Controller, { OnMount } from '@philips-emr/tws-core/lib/client';
import { MessageService } from '@philips-emr/tws-core/lib/services';

import { FragmentNames, RootAliases } from '../../codegen';

@Controller({ fragment: FragmentNames.ROOT })
export default class RootController {

  @OnMount(RootAliases.LAYOUT_ROOT)
  onMount(): void {
    document.title = MessageService.translate('beneficiary.application-name');
  }
}
